import * as React from 'react';
import { FoldersListItemNew } from '../../../components/FoldersList/FoldersListItem/FoldersListItemNew';
import { ModalCreateFolder } from '../../../components/FoldersList/create';
import { useDispatch, useSelector } from 'react-redux';
import { createFolder } from '../../../thunk/favorites';
import { selectUser } from '../../../selectors/user';
import { selectResults } from '../../../selectors';
import { trackCreateFolder } from './tracking';

export function CreateFolderContainer() {
  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const { favoriteEntities } = useSelector(selectResults);
  const [isModalOpened, setIsModalOpened] = React.useState(false);

  const handleConfirm = (name: string) => {
    setIsModalOpened(false);
    dispatch(createFolder(name));
    trackCreateFolder(favoriteEntities);
  };

  const handleClick = () => {
    if (user.isAuthenticated) {
      setIsModalOpened(true);
    } else {
      window.waitForLoginPopup();
    }
  };

  return (
    <React.Fragment>
      <ModalCreateFolder isVisible={isModalOpened} onConfirm={handleConfirm} onCancel={() => setIsModalOpened(false)} />
      <FoldersListItemNew onClick={handleClick} />
    </React.Fragment>
  );
}
